import { useState, useEffect } from 'react';
import openInNewTabAttr from '../../../services/helpers/openInNewTabAttr';
import { enableScroll, disableScroll } from '../../../services/helpers/scroll';
import MenuButton from './MenuButton';
import './MobileMenu.sass';

const MobileMenu = ({ mainLinks, menuItems }) => {
  const [menuVisibility, setMenuVisibility] = useState(false);
  const [selectedOption, setSelectedOption] = useState(null);
  const [activeSubLink, setActiveSubLink] = useState(null);

  useEffect(() => {
    if (menuVisibility) {
      disableScroll();
    } else {
      enableScroll();
    }
  }, [menuVisibility]);

  const toggleSubLink = (subLinkId) => {
    setActiveSubLink((prevSubLink) =>
      prevSubLink === subLinkId ? null : subLinkId
    );
  };

  return (
    <div className='mobile-menu-wrapper'>
      <MenuButton
        onClick={() => setMenuVisibility(!menuVisibility)}
        active={menuVisibility}
      />
      {menuVisibility && (
        <div className='mobile-menu-menu'>
          {selectedOption === null && (
            <>
              <div className='mobile-menu-top'>
                <p>¿En qué podemos ayudarte?</p>
                {mainLinks.map(({ id, link, newTab, title, subLinks }, i) => (
                  <>
                    {subLinks?.length > 0 && (
                      <div key={id} onClick={() => setSelectedOption(i)}>
                        <h2>
                          {title}
                        </h2>
                      </div>
                    )}
                    {subLinks?.length == 0 && (
                      <div key={id}>
                        <a href={link}>
                          <h2>{title}</h2>
                        </a>
                      </div>
                    )}
                  </>
                ))}
              </div>
              <div className='mobile-menu-bottom'>
                {menuItems.map(({ id, link, newTab, title }) => (
                  <a key={id} href={link} {...openInNewTabAttr(newTab)}>
                    {title}
                  </a>
                ))}
              </div>
            </>
          )}
          {selectedOption !== null && (
            <>
              <div className='mobile-menu-sublink-container'>
                <p onClick={() => setSelectedOption(null)}>
                  {mainLinks[selectedOption].title}
                </p>
                <div className='mobile-menu-dropdown-container'>
                  {mainLinks[selectedOption].subLinks.map((subLink) => (
                    <div
                      className='mobile-menu-dropdown-titles'
                      key={subLink.id}
                    >
                      <h2
                        onClick={() => toggleSubLink(subLink.id)}
                        style={{ cursor: 'pointer' }}
                      >
                        {subLink.title}
                      </h2>
                      {activeSubLink === subLink.id &&
                        subLink.links.locations &&
                        renderSubmenuLinks(subLink.links.locations)}
                    </div>
                  ))}
                </div>
              </div>
              <div className='mobile-menu-bottom'>
                {menuItems.map(({ id, link, newTab, title }) => (
                  <a key={id} href={link} {...openInNewTabAttr(newTab)}>
                    {title}
                  </a>
                ))}
              </div>
            </>
          )}
        </div>
      )}
    </div>
  );
};

export default MobileMenu;

const renderSubmenuLinks = (links) => (
  <div className='mobile-menu-sublinks-container'>
    {links.map((link) => (
      <a key={link.title} href={link.link}>
        {link.title}
      </a>
    ))}
  </div>
);
